import { Enum } from 'enumify';
import { startCase, head } from 'lodash';
import { replaceEnumUnsafe } from '../../util/transform';

export default class Enumerator extends Enum {
  static available() {
    return this.enumValues;
  }

  static default() {
    return head(this.enumValues);
  }

  static of(type?: string) {
    return this.enumValueOf(replaceEnumUnsafe(type)) || this.default();
  }

  title() {
    return startCase(this.name);
  }

  toString() {
    return this.name;
  }
}
